import { FC, ReactNode } from 'react';
import { Container, Stack, Typography, Box } from '@mui/material';
import { Phrase } from '@/types/types';
import styles from './errorblock.module.css';

interface ErrorBlockProps {
    icon?: ReactNode;
    title?: Phrase;
    text?: Phrase;
    fullWidth?: boolean;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({ icon, title, text, fullWidth = false }) => {
    return (
        <Container data-testid="error-block" sx={{ mt: 6, mb: 6, pt: 6, pb: 6 }}>
            <Stack
                direction="column"
                spacing={2}
                className={styles.container}
                sx={{
                    alignItems: 'center',
                }}
            >
                {icon && (
                    <Box className={styles.icon} sx={{ mb: 4 }}>
                        {icon}
                    </Box>
                )}
                {title && (
                    <Typography variant="h4" className={styles.title}>
                        {title}
                    </Typography>
                )}
                {text && (
                    <Typography
                        variant="caption"
                        className={styles.text}
                        style={fullWidth ? { maxWidth: '85%' } : {}}
                    >
                        {text}
                    </Typography>
                )}
            </Stack>
        </Container>
    );
};
